import React, { useEffect } from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { useTranslation, withTranslation } from 'react-i18next';
import Modal from "../../Modal";
import EmailTemplate from "../../EmailTemplate";
import commonActions from "../../../Actions/commonActions";
import customerActions from "../../../Actions/customerActions";
import Spinner from "../../Fundamentals/Spinner/Spinner";
function EducationEmailModal({commonActions, form, togglemodal, customerActions, selectedCourse}) {

    const { t } = useTranslation();
    const getEducatioInfoHtmlString = (course) => {
        let educationDays = course.days ? `Dagar: ${course.days}<br>` : '';
        let educationInfoHtmlString = `
                <h2>Kursinformation</h2>
                Namn: ${course.courseName}<br>
                ${educationDays}
                Nivå: ${course.courseLevel}<br>
                Kategorier: ${course.subjects && course.subjects.join(', ')}<br>
                <br>
                `;

        educationInfoHtmlString += course.targetGroup ? `<p>${course.targetGroup}</p>` : '';
        educationInfoHtmlString += course.courseDescription;
        educationInfoHtmlString += course.notes !== null ? course.notes : "";
        educationInfoHtmlString += course.prerequisites;
        educationInfoHtmlString += course.courseGoal;
        return educationInfoHtmlString;
    }
    
    useEffect(() => {
        if (selectedCourse) {
            const educationInfoHtmlString = getEducatioInfoHtmlString(selectedCourse);
            commonActions.getEducationInformationTemplate(educationInfoHtmlString);
        }
    }, [selectedCourse])
    
    useEffect(() => {
        return () => {
            if (form)
                commonActions.cancelFormEditing(form.id);
            customerActions.clearSelectedCourse();
        }
    }, [])

    const handleClickClose = () => {
        togglemodal();
    }

    const handleFieldChange = (field, value) => {
        commonActions.changeMultiFormField(form.id, field, value);
    }

    const handleClickSave = () => {
        commonActions.sendEducationInformation(form);
        togglemodal();
    }

    const modalProps = {
        title: t('educations.sendinfo'),
        mainButtonTitle: t('common.send'),
        onCancelClick: handleClickClose,
        stateful: true,
        open: true,
        onChange: handleFieldChange, 
        onSaveClick: handleClickSave,
    }

    return (
    <Modal {...modalProps}>
        {!form || !selectedCourse ? <Spinner /> :
        <EmailTemplate data={form && form.data} templates={null} onChange={handleFieldChange} onSaveClick={handleClickSave} onCancelClick={handleClickClose}/>}
    </Modal>
    )
}

function mapStateToProps(state) {
    return {
        form: state.CommonReducer.forms && state.CommonReducer.forms.sendEducationInformationForm,
        selectedCourse: state.CustomerReducer.selectedCourse,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        commonActions: bindActionCreators(commonActions, dispatch),
        customerActions: bindActionCreators(customerActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EducationEmailModal));